export const workflowKeys = {
  prefix: 'workflow',
  detail: (folderId: string) => [workflowKeys.prefix, 'detail', folderId],
  update: (folderId: string) => [workflowKeys.prefix, 'update', folderId],
  create: (folderId: string) => [workflowKeys.prefix, 'create', folderId],
}
